export function routeToLot (lotId, role) {
    const to = { name: "lots.show", params: { id: lotId } };

    if(['admin','operator','operator-buhgalter'].includes(role)) {
        to.name = 'lots.show.admin';
    }
    if(['organizer'].includes(role)) {
        to.name = 'lots.show.organizer';
    }

    return to
}
